import { capitalizeText } from 'src/util/formatters/stringNormalizer';
import { toEchartData } from '../dataProcessor';

export default function toEchartOption(resultadosGerais, theme, chartFontSize = 14, disabledLegends, highlitIndex) {
  const echartData = toEchartData(resultadosGerais);
  const { data, legends } = echartData;

  /**
   * Refere-se a um sub-pergunta da pergunta do tipo grade
   */
  const lines = [...new Set(data.map((value) => value.label).reverse())];

  /**
   * Tratando os dados para ficar de forma reverse e ordenado de acordo com:
   * 1. linhas do gráfico
   * 2. legenda do gráfico
   */
  const seriesData = [...data].reverse()
    .sort((a, b) => {
      if (lines.indexOf(a.label) < lines.indexOf(b.label)) return -1;
      if (lines.indexOf(a.label) > lines.indexOf(b.label)) return 1;
      return 0;
    })
    .sort((a, b) => {
      if (legends.indexOf(a.name) < legends.indexOf(b.name)) return -1;
      if (legends.indexOf(a.name) > legends.indexOf(b.name)) return 1;
      return 0;
    });

  const dataset = {
    dimensions: ['items', ...legends],
    source: (() => {
      const sourceItems = [];

      seriesData.forEach((serieItem) => {
        let sourceItem = sourceItems.find((sourceObj) => sourceObj.items === serieItem.label);
        if (!sourceItem) {
          sourceItem = {
            items: serieItem.label,
          };
          sourceItems.push(sourceItem);
        }
        sourceItem[serieItem.name] = serieItem.value;
        sourceItem[`${serieItem.name}_NUMERIC`] = serieItem.numeric;
      });

      return sourceItems.reverse();
    })(),
  };

  const selectedLegends = {};
  const series = legends.map((legend, index) => {
    selectedLegends[legend] = !disabledLegends.includes(legend);
    return {
      type: 'bar',
      name: legend,
      label: {
        show: true,
        position: 'top',
        formatter: (v) => `${v.value[v.seriesName]}%`,
        textStyle: {
          fontSize: chartFontSize,
          color: theme.label.text,
        },
      },
      itemStyle: {
        ...(index === highlitIndex ? {
          borderType: theme.highlitedItemBorderType,
          borderColor: theme.highlitedItemBorderColor,
          borderWidth: theme.highlitedItemBorderWidth,
        } : {})
      },
    };
  });

  const tooltipFormatter = (stackItens) => {
    const first = stackItens[0];
    const output = stackItens
      .map((item) => `${item.marker} ${item.seriesName}: ${item.data[`${item.seriesName}_NUMERIC`]} (${item.data[item.seriesName]}%)`)
      .reduce((reduced, next) => reduced.concat('<br>').concat(next));
    const title = first.name;
    return `${title}<br>${output}`;
  };

  return {
    color: theme.colors,
    animationDuration: 0,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: tooltipFormatter,
    },
    legend: {
      selected: selectedLegends,
      icon: 'circle',
      top: '-1%',
      type: 'scroll',
      textStyle: {
        color: theme.legend.color,
        fontSize: chartFontSize,
        fontFamily: 'Roboto, sans-serif'
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    grid: {
      left: '3%',
      right: '15%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      axisLabel: {
        textStyle: {
          color: theme.axis.x.label,
        },
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.x.line,
        },
      },
    },
    yAxis: {
      axisLabel: {
        textStyle: {
          color: theme.axis.x.label,
        },
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.x.line,
        },
      },
    },
    dataset,
    series,
  };
}
